
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSnackError } from '../Reducers/snackErrors';
import { setSuccessSnack } from '../Reducers/snackSuccess';
import { sessionService } from '../Services/sessionService';

export const useGetSessions = () => {

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const endSession = async (id) => {
    setLoading(true);
    try {
      const data = await sessionService.endSession(id);
      if (data.status === 'OK') {
        dispatch(setSuccessSnack({
          title: 'OK',
          body: 'Successfully ended session.'
        }));
        return true;
      }
      return false;
    } catch (error) {
      if (error.isAuthError || error.isForbidden) {
        return false;
      }
      if (error.isNetworkError) {
        dispatch(setSnackError({ 
          title: 'Connection Error', 
          body: error.message 
        }));
      } else {
        dispatch(setSnackError({
          title: 'Error found',
          body: error.message || 'Unable to end session.'
        }));
      }
      return false;
    } finally {
        setLoading(false);
    }
  }

  const checkCompletedSession = async (id) => {
    setLoading(true);
    try {
      const data = await sessionService.checkValidSession(id);
      if ( data ) { return data; }
      return false;
    } catch (error) {
      if (error.isAuthError || error.isForbidden) {
        return false;
      }
      if (error.isNetworkError) {
        dispatch(setSnackError({ 
          title: 'Connection Error', 
          body: error.message 
        }));
      } else {
        dispatch(setSnackError({
          title: 'Error found',
          body: error.message || 'Unable to check valid session.'
        }));
      }
      return false;
    } finally {
        setLoading(false);
    }
  }

  return { 
    endSession,
    checkCompletedSession,
    loading,
  };
};